define('businessServices/signup/signupResumeDestinationStore',[
    'common/storage/browserTabStorage'
], function() {
    return function() {
        const self = this;

        const _browserTabStorage = require('common/storage/browserTabStorage');

        const STORAGE_NAME = "TrestaSignupResumeDestination";

        // Deliberately tab-scoped and single-use. A continuation that outlived the browser
        // session would send a returning customer straight past the onboarding welcome
        // screen, which they are meant to see on every ordinary login.
        self.save = (destinationUrl) => {
            _browserTabStorage.saveObject(STORAGE_NAME, {destinationUrl: destinationUrl});
        };

        self.consume = () => {
            const storedDestination = _browserTabStorage.getObject(STORAGE_NAME);
            if (storedDestination === null || !storedDestination.destinationUrl) {
                return null;
            }

            _browserTabStorage.deleteObject(STORAGE_NAME);
            return storedDestination.destinationUrl;
        };

        self.clear = () => {
            _browserTabStorage.deleteObject(STORAGE_NAME);
        };
    };
});

